import React, { useEffect, useState } from "react"
import { IconButton, makeStyles, Chip } from "@material-ui/core"
import { Icon, LoadingSpinner, TooltipIcon } from ".."

const useStyles = makeStyles(() => ({
  delete: {
    cursor: "pointer",
    opacity: 0.7,
    "&:hover": {
      opacity: 1,
    },
  },
  iconRef: {
    display: "flex",
    flexDirection: "row",
  },
}))

const DeleteConfirmIconButton = ({
  deleting: deletingInput = false,
  confirmLabel = "",
  confirmTooltip = "Confirm delete",
  onDeleting,
  onDelete,
  loading,
  cy = "DeleteConfirmIconButton",
}) => {
  const classes = useStyles()
  const [deleting, setDeleting] = useState(deletingInput)

  useEffect(() => {
    setDeleting(deletingInput)
  }, [deletingInput])

  const handleDeleting = () => {
    setDeleting(true)
    onDeleting && onDeleting()
  }

  const handleCancelDeleting = () => {
    setDeleting(false)
  }

  const handleDelete = () => {
    onDelete && onDelete()
    setDeleting(false)
  }

  if (loading) {
    return <LoadingSpinner size={20} />
  }

  return (
    <>
      {deleting && (
        <Chip
          icon={
            <TooltipIcon
              name="delete"
              tooltip={confirmLabel ? "" : confirmTooltip}
              className={classes.delete}
              onClick={handleDelete}
              refClassName={classes.iconRef}
              data-cy={`${cy}-confirm`}
            />
          }
          deleteIcon={
            <TooltipIcon name="cancel" tooltip="Cancel" refClassName={classes.iconRef} data-cy={`${cy}-cancel`} />
          }
          label={confirmLabel}
          color="secondary"
          onDelete={handleCancelDeleting}
        />
      )}
      {!deleting && (
        <IconButton edge="end" aria-label="delete" size="small" onClick={handleDeleting} data-cy={`${cy}-delete`}>
          <Icon name="delete" />
        </IconButton>
      )}
    </>
  )
}

export { DeleteConfirmIconButton }
